module.exports = __webpack_public_path__ + "assets/icon-batteryContainer-without.c3251639.svg";